import { useNavigate } from 'react-router-dom';
import { MoldOrder } from '../../types/mold';
import { ClipboardList } from 'lucide-react';

const ViewQuestionnaireButton: React.FC<{ moldOrder: MoldOrder }> = ({
  moldOrder,
}) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(`/questionnaires/${moldOrder.id}?mode=view`)}
      className='shadow-md text-base w-full py-3 px-4 rounded-lg flex items-center justify-center bg-white border-2 border-blue-500 text-blue-500 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
      data-cy='view-questionnaire-button'
    >
      <ClipboardList className='h-5 w-5 mr-2' />
      <span>ดูใบงาน</span>
    </button>
  );
};

export default ViewQuestionnaireButton;
